import { render, staticRenderFns } from "./SpaceDetail.vue?vue&type=template&id=4e14c7fc"
import script from "./SpaceDetail.vue?vue&type=script&lang=js"
export * from "./SpaceDetail.vue?vue&type=script&lang=js"
import style0 from "./SpaceDetail.vue?vue&type=style&index=0&id=4e14c7fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports